/**
 * Buscar sin que las tildes estorben.
 *
 * ═══════════════════════════════════════════════════════════════════════════════
 *  EL PROBLEMA
 * ═══════════════════════════════════════════════════════════════════════════════
 *
 * Un catálogo de bodega venezolana está lleno de tildes: azúcar, café, jabón,
 * atún, maíz, limón, plátano, champú, piña. Y nadie las escribe en una caja, con
 * un cliente delante y el teclado de un teléfono.
 *
 * «azucar» no encontraba «Azúcar Montalbán», y el cajero concluía que el
 * producto no estaba cargado. Lo malo no es no encontrarlo: es lo que hace
 * después — crearlo otra vez, y ahora el inventario tiene dos azúcares.
 *
 * ⚠️ ESTO TIENE QUE APLANAR IGUAL QUE EL SERVIDOR (`core/busqueda.py`), o la
 * misma palabra encontraría cosas distintas según haya internet o no: la
 * pantalla de vender busca en el catálogo que guarda el navegador, y el resto
 * pregunta al servidor. Dos respuestas para lo mismo es peor que ninguna.
 *
 * `NFD` separa cada letra de su tilde y luego se tira la tilde. La ñ se aplana
 * también —quien busca escribe «pina» por «piña»—, igual que hace el servidor.
 */
export function sinTildes(texto: string): string {
  return texto
    .normalize("NFD")
    /*
      Fuera las tildes que `NFD` acaba de separar de su letra.

      ⚠️ `\p{Mn}` —«marca que no ocupa sitio»— y no un rango de caracteres
      escrito a mano. Un rango hay que teclearlo con los caracteres dentro, y
      son INVISIBLES: no se ve si están bien, y una copia entre editores se los
      come sin dejar rastro. Esto es ASCII y dice lo que hace.
    */
    .replace(/\p{Mn}/gu, "")
    .replace(/ç/gi, "c")
    .toLowerCase();
}

/**
 * ¿El texto contiene lo buscado, ignorando tildes y mayúsculas?
 *
 * Sustituye a `algo.toLowerCase().includes(q)`, que es lo que había en los
 * veintitantos buscadores de la aplicación. Acepta null y undefined porque
 * media aplicación busca en campos opcionales —el nombre del cliente de una
 * venta, el proveedor de una entrada— y encadenar `?? ""` en cada sitio es
 * justo lo que se olvida en el siguiente.
 */
export function contieneSinTildes(
  texto: string | null | undefined,
  buscado: string,
): boolean {
  if (!texto) return false;
  return sinTildes(texto).includes(sinTildes(buscado));
}
